import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import axios from 'axios'
import Crud from '../crud'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'

const model = (payload) => ({
  // columns
  id: payload.id,
  date: moment(payload.date).format('YYYY-MM-DD'),
  conceptable_type: payload.conceptable_type,
  conceptable_id: payload.conceptable_id,
  concept: payload.concept,
  payment: payload.payment || 0,
  charge: payload.charge || 0,
  status: payload.status
})
var crud = new Crud('Concepts', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  concepts: [],
  catalog: {
    projects: [],
    administrative_concepts: [],
    suppliers: []
  }
}

const mutations = {
  ...crud.mutations,
  CHANGE_STATUS (state, payload) {
    const idx = state.concepts.findIndex(u => u.id === payload.id)
    state.concepts[idx] = payload
    if (idx >= 0) {
      Vue.set(state.concepts, idx, payload)
    }
  },
  UPDATE_RECORDS (state, payload) {
    const idx = state.concepts.findIndex(u => u.id === payload.id)
    state.concepts[idx] = payload
    if (idx >= 0) {
      Vue.set(state.concepts, idx, payload)
    }
  },
  ADD_CONCEPT (state, payload) {
    state.concepts.unshift(payload)
  }
}

const actions = {
  ...crud.actions,
  async setEarlyDateAlert ({ commit }) {
    commit('SET_ALERT_MESSAGE', { color: 'warning', title: 'errors.warning', text: 'errors.early_date' }, { root: true })
  },
  async setFutureDateAlert ({ commit }) {
    commit('SET_ALERT_MESSAGE', { color: 'warning', title: 'errors.warning', text: 'errors.future_date' }, { root: true })
  },
  async addRecord ({ commit }, payload) {
    const record = model(payload)
    app.$Progress.start()

    try {
      const response = await axios.post('concepts', record)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_CONCEPT', response.data)
        commit('Dashboard/ADD_CONCEPT', response.data, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.concepts', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editRecord ({ commit }, payload) {
    const record = model(payload)

    app.$Progress.start()
    try {
      const response = await axios.put(`concepts/${payload.id}`, record)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORDS', response.data)
        commit('Dashboard/UPDATE_CONCEPTS', response.data, { root: true })

        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.concepts', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }

}

const getters = {
  ...crud.getters,
  concepts: state => state.concepts,
  catalog: state => state.catalog
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
